import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import ReactToPrint from "react-to-print";
import { useSelector } from "react-redux";
import "./printBilling.css";
import { ApplyAccordingREAndCBUser } from "../features/counterSellBilling/counterSellBillFunctions";

import {
  receiptDateFormate,
  receptTime,
} from "./commonUtils/commonUtilFunction";
import QrCodeGenrate from "./qrCodeGenerate";
export default function PrintBilling({
  componentRef,
  currentDataArr,
  tableName,
  userDetail,
  addDataCallBack,
  setKOT,
  paybill,
  setOpen2,
  payableBilUpdateBill,
  totalAmountBill,
  discountAmount,paymentAttribute,
  addtoCardProductCBUser,
  bill,
  priceWithoutGst,
}) {
  const billNumber = useSelector((state) => state.reducer.billNumber);
  const handlePrint = () => {
    if (componentRef && componentRef.current) {
      componentRef?.current?.onClick();
    }
  };

  React.useEffect(()=>{
    console.log("componentRef ",componentRef)
  },[])


  // const userDetail = useSelector((state) => state.reducer.userDetail);

console.log(paybill,'paybillpaybill')
  return (
    <Box
      sx={{
        background: "white",
        display: "none",
        position: "absolute",
        left: "30%",
        top: "20vh",
        overflowY: "auto",
        maxHeight: "80vh",
        p: "0px 10px",
        width: userDetail?.printerSize == 3 ? "80mm" : "48mm",
      }}
    >
      <Box
        ref={componentRef}
        sx={{
          minWidth: userDetail?.printerSize == 2 ? "48mm" : "none",
          maxWidth: userDetail?.printerSize == 3 ? "80mm" : "none", // Adjust the maximum width to fit the print paper size
          margin: userDetail?.printerSize == 3 ? "10px" : "0px",

          boxSizing: "border-box",

        }}
      > 



<Box 
        sx={{
          textAlign:'center'

        }}
      > 


{userDetail?.uploadedLogo && 
        ( <img
          src={userDetail?.uploadedLogo}
          alt="Selected"
          // onClick={handleIconClick}
          style={{
             width: userDetail?.printerSize == 2? '100px':"120px",
                 height: userDetail?.printerSize == 2? '100px':"120px",
                  cursor: 'pointer', 
                  borderRadius: '50%',
                  marginTop:"10px"
                 }}
        />)

        }
      </Box>






        
        <Typography
          variant="subtitle1"
          textAlign="center"
          sx={{
            margin: "0px",
            p: "0px",
            fontSize:  userDetail?.printerSize == 2?"14px":"18px",

            lineHeight: "1.2",
            fontWeight: "600",
          }}
        >
          {userDetail?.myBusinessName}
        </Typography>
        <Box
          sx={{
            width: "100%",
          }}
        >
          <Typography
            variant="subtitle1"
            textAlign="center"
            sx={{
              margin: "0px",
              p: "0px",
              fontSize: userDetail?.printerSize == 3 ? "15px" : "12px",
              lineHeight: "1.2",
            }}
          >
            {userDetail?.billerAddress}
          </Typography>
          <Typography
            variant="subtitle1"
            textAlign="center"
            sx={{
              margin: "0px",
              lineHeight: "1.2",
              p: "0px",
              fontSize: userDetail?.printerSize == 3 ? "15px" : "12px",
            }}
          >
            PH-NO:{userDetail?.mobileNumber}
          </Typography>

          <Typography
            variant="subtitle1"
            textAlign="center"
            sx={{
              margin: "0px",
              lineHeight: "1.2",
              // p: "0px 0px 0px 0px",
              m: "0px 10px 0px 0px",
              fontSize: userDetail?.printerSize == 3 ? "15px" : "11px",
            }}
          >
            BILL NO :{billNumber + 1}
            {"    "}
            <span style={{ margin: "4px" }}></span>
            {receiptDateFormate()}
            {"  "}
            {receptTime()}
          </Typography>
          <Typography
            variant="subtitle1"
            textAlign="center"
            sx={{
              margin: "0px",
              p: "0px",
              lineHeight: "1.2",
              fontSize: "20px",
              fontWeight: "600",
            }}
          >
            {ApplyAccordingREAndCBUser(
              userDetail,
              () => tableName,
              () => ""
            )}
          </Typography>
        </Box>

        <Box
          sx={{
            paddingLeft: userDetail?.printerSize === 3 ? "10px" : "0px",
          }}
        >
          <Grid container>
            <Grid
              item
              container
              sx={{
                borderBottom: "1px dashed black",
                borderTop: "1px dashed black",
              }}
            >
              <Grid
                item
                container
                sx={{
                  borderBottom: "1px dashed black",
                }}
              >
                <Grid item xs={12} sx={{ 
                  pt:"4px",
                  fontSize: userDetail?.printerSize == 2?"12px":"14px"
                   }}>
                  ITEM
                </Grid>
                <Grid item xs={2.5} sx={{ 
                   pt:"4px",
                   pb:"4px",
                                    fontSize: userDetail?.printerSize == 2?"12px":"14px"
                 }}>
                  QTY
                </Grid>
                <Grid
                  item
                  xs={5}
                  sx={{ 
                     pt:"4px",
                                        pb:"4px",
                                      fontSize: userDetail?.printerSize == 2?"12px":"14px", textAlign: "center" }}
                >
                  RATE
                </Grid>
                {/* <Grid
                  sx={{ fontSize: "14px", textAlign: "center" }}
                  item
                  xs={3}
                >
                  GST
                </Grid> */}
                <Grid sx={{  
                   pt:"4px",   
                                      pb:"4px",             fontSize: userDetail?.printerSize == 2?"12px":"14px"}} item xs={4}>
                  TOTAL
                </Grid>
              </Grid>

              {ApplyAccordingREAndCBUser(
                userDetail,
                () => {
                  return currentDataArr;
                },
                () => {
                  return addtoCardProductCBUser;
                }
              )?.length > 0 &&
                ApplyAccordingREAndCBUser(
                  userDetail,
                  () => {
                    return currentDataArr;
                  },
                  () => {
                    return addtoCardProductCBUser;
                  }
                )?.map((ele, index) => {
                  console.log("eee update ", ele, " ", index);
                  return (
                    <React.Fragment key={"Billinglist" + index}>
                      <Grid
                        item
                        xs={12}
                        sx={{                   fontSize: userDetail?.printerSize == 2?"12px":"14px", marginY: "3px" }}
                      >
                        <Typography></Typography>

                        { }
                        {ApplyAccordingREAndCBUser(
                          userDetail,
                          () => {
                            return (ele[1] === undefined
                              ? ele.itemDescription
                              : ele[1].itemDescription);
                          },
                          () => {
                            return ele.itemDescription;
                          }
                        )}
                      </Grid>
                      <Grid
                        item
                        xs={2.5}
                        sx={{
                                          fontSize: userDetail?.printerSize == 2?"12px":"14px",
                          overflowWrap: "break-word !important",
                        }}
                      >
                        {" "}
                        {ApplyAccordingREAndCBUser(
                          userDetail,
                          () => {
                            return      ele.quantity
                              
                          },
                          () => {
                            return parseFloat(ele.suppliedQuantity??0).toFixed(2);
                          }
                        )}
                        { }
                      </Grid>
                      <Grid
                        item
                        xs={5}
                        sx={{
                                           fontSize: userDetail?.printerSize == 2?"12px":"14px",
                          textAlign: "center",
                          paddingX: "2px",
                          overflowWrap: "break-word !important",
                        }}
                      >
                        {ele.rate?.toFixed(2)}
                        
                      </Grid>

                      {/* <Grid
                        item
                        xs={3}
                        sx={{
                          fontSize: "14px",
                          textAlign: "center",
                          paddingX: "2px",
                          overflowWrap: "break-word !important",
                        }}
                      >
                        {" "}
                        {ApplyAccordingREAndCBUser(
                          userDetail,
                          () => {
                            return ele[1] === undefined
                              ? ele.gst?.toFixed(1)
                              : ele[1].gst == 0
                                ? "-"
                                : ele[1].gst?.toFixed(1) + "%";
                          },
                          () => {
                            return ele.gst?.toFixed(1) <= 0
                              ? "-"
                              : ele.gst?.toFixed(1) + "%";
                          }
                        )}
                        { }
                      </Grid> */}
                      <Grid
                        item
                        xs={4}
                        sx={{
                                            fontSize: userDetail?.printerSize == 2?"12px":"14px",
                          textAlign: "left",
                          overflowWrap: "break-word !important",
                        }}
                      >
                        {(ele.quantity * ele.rate).toFixed(
                                2
                              )}
                       
                        
                      </Grid>
                    </React.Fragment>
                  );
                })}
            </Grid>
            
 <Grid
                item
                xs={6}
                sx={{
                  

                  
                    m:0,p:0,
                  textAlign: "center",
                  fontWeight: "500", 
                  
                }}
              > <Typography
                  sx={{

                    m:0,p:0,
                    overflowWrap: "break-word !important", 
                    fontSize: "12px",
                  }}
                >
                  Sub Total  
                </Typography>

              </Grid>
               <Grid
                item
                xs={6}
                sx={{ 
                  
                    m:0,p:0,
                  textAlign: "center",
                  fontWeight: "500", 
                  
                }}
              >
<Typography
                  sx={{

                    m:0,p:0,
                    overflowWrap: "break-word !important", 
                    fontSize: "12px",
                  }}
                >
               : Rs.{" "} {priceWithoutGst?.toFixed(2)} {" "}
                </Typography>


              </Grid>
                        
 {paymentAttribute?.cgst && paymentAttribute?.cgst!=0 && <Grid
                item
                xs={6}
                sx={{
                  

                    m:0,p:0,
                  
                  textAlign: "center",
                  fontWeight: "500", 
                  
                }}
              > <Typography
                  sx={{
                    m:0,p:0,
                    overflowWrap: "break-word !important", 
                    fontSize: "12px",
                  }}
                >
                  CGST
                </Typography>

              </Grid>}
              {paymentAttribute?.cgst && paymentAttribute?.cgst!=0 && <Grid
                item
                xs={6}
                sx={{ 
                  
                    m:0,p:0,
                  textAlign: "center",
                  fontWeight: "500", 
                  
                }}
              >
<Typography
                  sx={{
                    m:0,p:0,
                    overflowWrap: "break-word !important", 
                    fontSize: "12px",
                  }}
                >
               : Rs. {" "}{ paymentAttribute?.cgst??0} {" "}
                </Typography>


              </Grid>}

      {paymentAttribute?.igst!=0 &&                         
 <Grid
                item
                xs={6}
                sx={{
                  

                  
                  textAlign: "center",
                  fontWeight: "500", 
                  
                }}
              > <Typography
                  sx={{
                    overflowWrap: "break-word !important", 
                    fontSize: "12px",
                  }}
                >
                     IGST
                </Typography>

              </Grid>}
             {paymentAttribute?.igst!=0 &&  <Grid
                item
                xs={6}
                sx={{ 
                  
                  textAlign: "center",
                  fontWeight: "500", 
                  
                }}
              >
<Typography
                  sx={{
                    overflowWrap: "break-word !important", 
                    fontSize: "12px",
                  }}
                >
               : Rs. {" "}{ ( paymentAttribute?.igst??0)} {" "}
                </Typography>


              </Grid>}
                                           
 {paymentAttribute?.sgst && paymentAttribute?.sgst!=0 && <Grid
                item
                xs={6}
                sx={{
                  

                  
                  textAlign: "center",
                  fontWeight: "500", 
                  
                }}
              > <Typography
                  sx={{
                    overflowWrap: "break-word !important", 
                    fontSize: "12px",
                  }}
                >  



                SGST
                </Typography>

              </Grid>}
              {paymentAttribute?.sgst && paymentAttribute?.sgst!=0 && <Grid
                item
                xs={6}
                sx={{ 
                  
                  textAlign: "center",
                  fontWeight: "500", 
                  
                }}
              >
<Typography
                  sx={{
                    overflowWrap: "break-word !important", 
                    fontSize: "12px",
                  }}
                >
              : Rs. {" "}{( paymentAttribute?.sgst??0)} {" "}
                </Typography>


              </Grid>
}
              

              



   {discountAmount &&                                        
 <Grid
                item
                xs={6}
                sx={{
                  

                  
                  textAlign: "center",
                  fontWeight: "500", 
                  
                }}
              > <Typography
                  sx={{
                    overflowWrap: "break-word !important", 
                    fontSize: "12px",
                  }}
                >  



                 Discount
                </Typography>

              </Grid>}
            {discountAmount &&   <Grid
                item
                xs={6}
                sx={{ 
                  
                  textAlign: "center",
                  fontWeight: "500", 
                  
                }}
              >
<Typography
                  sx={{
                    overflowWrap: "break-word !important", 
                    fontSize: "12px",
                  }}
                >
              : Rs. {" "}{ (parseFloat(discountAmount) ??0).toFixed(2)}
                </Typography>


              </Grid>}
            
           
            <Grid
              item
              xs={12}
              sx={{
                textAlign: "center",
                fontWeight: "500",
borderTop: "1px dashed black",
                borderBottom: "1px dashed black",
                
              }}
            >
              <Typography
                sx={{
                  fontWeight:"bold", 
                   
                  fontSize: "12px",
                }}
              >
                 TOTAL AMOUNT: Rs.{" "} {paybill}
                
                   
                {/* // : payableBilUpdateBill() // ? */}
                {/* payableBilUpdateBill()?.toFixed(2) // : 0?.toFixed(2)}{" "} */}
              </Typography>
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                textAlign: "center",
                mt: 1
              }}
            >
              <Typography sx={{ fontSize: "12px" }}>
                THANKS VISIT AGAIN
              </Typography>
            </Grid>
            {userDetail?.isPrintQRCodeOnBill && (
              <> 
              <Grid item xs={12} sx={{
                display: "grid",
                mt: 1,
                placeItems: "center"
              }}>
                <QrCodeGenrate amount={paybill
                  // ? paybill?.toFixed(2)
                  // : payableBilUpdateBill
                  //   ? payableBilUpdateBill()?.toFixed(2)
                  //   : 0?.toFixed(2)
                    } />
              </Grid>
               <Grid
              item
              xs={12}
              sx={{
                textAlign: "center",
                fontWeight: "500",
                borderTop: "1px dashed black",
                borderBottom: "1px dashed black",
                paddingY: "5px",
                mt: 1
              }}
            >
              <Typography
                sx={{
                  overflowWrap: "break-word !important",
                  fontWeight: "bold",
                  fontSize: "12px",
                }}
              >
                Scan To Pay
              </Typography>
            </Grid>
               </>
            )}

           
          </Grid>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",

          justifyContent: "space-around",
        }}
      >
        <ReactToPrint
          trigger={() => (
            <Button
              variant="contained"
              sx={{
                mt: "10px",
                display: "inline-block",
                mb: "10px",
              }}
              onClick={() => {
                setKOT();
                addDataCallBack();
                setOpen2(false);
              }}
            >
              {" "}
              Print
            </Button>
          )}
          content={() => componentRef.current}
          onBeforePrint={() => {
            setOpen2(false);

            addDataCallBack();
          }}
        ></ReactToPrint>
        <Button
          variant="contained"
          sx={{
            m: "10px",
          }}
          onClick={() => {
            handlePrint();
            // if (bill?.customerMobile?.length === 10) {
            //   addDataCallBack();
            //   shareOnWhatsApp(
            //     userDetail,
            //     getItemDetails,
            //     bill,
            //     billNumber,
            //     paybill,
            //     tableName,
            //     totalAmountBill,
            //     ApplyAccordingREAndCBUser,

            //     currentDataArr,
            //     addtoCardProductCBUser
            //   );
            // } else {
            //   Swal.fire({
            //     text: "Please Enter Mobile Number",
            //     icon: "error",

            //     ...swalAlertPopProps,
            //   });
            // }
            // setOpen2(false);
          }}
        >
          {" "}
          Share
        </Button>
      </Box>
    </Box>
  );
}
